import React, { useCallback, useMemo } from 'react'
import { useState, useEffect, useRef, useLayoutEffect } from 'react'
import {
    View,
    Text,
    TouchableOpacity,
    Image,
    Dimensions,
    Alert,
    StyleSheet,
    ActivityIndicator,
    PixelRatio,
    Share,
    Platform,
    Animated,
} from 'react-native'
import { isIOS } from '../../utils/platformUtils'
import theme from '../../../theme'
import StyledText from '../../../StyledText'
import parseThousands from '../customUtils/parseThousands/parseThousands'
// import { fetchAuthSession } from 'aws-amplify/auth'
import { signOut } from 'aws-amplify/auth'
import { getAuthToken } from '../../utils/functions.utils'
import { Ionicons, Feather, FontAwesome, MaterialCommunityIcons } from '@expo/vector-icons'
import { apiUrl, apiUrlWSocket } from '../../config/config'
import { useSelector } from 'react-redux'
import { update_like_local_posts, get_post_by_id, update_favourite_local_posts } from '../../db/posts/index'
import { useBottomSheet } from '../customUtils/context/BottomSheetContext'
import { FlatList } from 'react-native-gesture-handler'
import { openDB, addReaction, getAllReactions } from '../../db/indexDB'
import CustomAlert from '../customUtils/Components/CustomAlert'
import awsconfig from '../../aws-exports'
import { getImageStogeUrl } from '../imageUploader/ImageStorage'
import { getAvatarFromCache, setAvatarInCache } from '../../utils/ttlCache'
import styles from './InteractionsPostsStyles'
import { avatarPlaceholder } from '../customUtils/Constants'
import { TrackingServices } from '../../../database/tracking.database'
import { getLanguage } from '../appBar/context/LocalizationContext'
import { usePostContext } from './context/posts.context'
import { StatusBar } from 'react-native'
import { getConection } from '../appBar/context/HeaderContext'
import { getAlert } from '../appBar/context/AlertsContext'
import Constants from 'expo-constants'
import { removeCacheByFragment } from '../../utils/FetchServices'
import { PostTagsTheme } from '../../../themeConstants'
import { debug, info, warn, error, lazy } from '../../utils/logger'
import { enqueue, createAction, subscribeFlushOnReconnect } from '../../services/offline/offlineQueue'
import { getReactionAsset, normalizeReactionName, applyOptimisticReaction } from './utils/reactionAssets'
import { useInteractionsStore } from '../../redux/zustand/interactionsPostStore'

const LIKE_KEY = 'like'

// Sin catálogos por defecto: el catálogo autorizado viene de single.reactions y se pasa por props

// Memo cache simple en módulo para URLs de avatar resueltas (hot cache)
const __avatarCache = new Map()

const UserReactionItem = ({ userReaction }) => {
    const [avatar, setAvatarUrl] = useState(null)

    useEffect(() => {
        let mounted = true
        const key = userReaction?.avatar
        const hit = key ? __avatarCache.get(key) : null
        if (hit) {
            const hitStr = typeof hit === 'string' ? hit : hit && typeof hit.toString === 'function' ? hit.toString() : null
            if (hitStr) setAvatarUrl(hitStr)
            return
        }
        if (key) {
            // 1) Intentar cache persistente con TTL
            getAvatarFromCache(key)
                .then((cached) => {
                    if (!mounted) return
                    if (cached) {
                        const cachedStr =
                            typeof cached === 'string' ? cached : cached && typeof cached.toString === 'function' ? cached.toString() : null
                        if (cachedStr) {
                            __avatarCache.set(key, cachedStr)
                            setAvatarUrl(cachedStr)
                            return true
                        }
                        return true
                    }
                    return false
                })
                .then((servedFromCache) => {
                    if (servedFromCache) return
                    // 2) Resolver desde Storage si no hubo hit
                    getImageStogeUrl(key)
                        .then(async (url) => {
                            if (!mounted) return
                            if (url) {
                                const urlStr = typeof url === 'string' ? url : url && typeof url.toString === 'function' ? url.toString() : null
                                if (!urlStr) return
                                __avatarCache.set(key, urlStr)
                                setAvatarUrl(urlStr)
                                // guardar persistente con TTL (24h por defecto)
                                try {
                                    await setAvatarInCache(key, urlStr)
                                } catch {}
                            }
                        })
                        .catch(() => {})
                })
                .catch(() => {})
        }
        return () => {
            mounted = false
        }
    }, [userReaction])

    return (
        <View style={styles.container}>
            <View style={styles.cantainerDataUser}>
                {(() => {
                    let src
                    if (typeof avatar === 'number') {
                        src = avatar
                    } else if (avatar && typeof avatar === 'object' && typeof avatar.toString === 'function') {
                        // Puede venir como instancia URL u objeto con toString(); forzamos a string
                        src = { uri: avatar.toString() || avatarPlaceholder }
                    } else if (typeof avatar === 'string') {
                        src = { uri: avatar || avatarPlaceholder }
                    } else {
                        src = { uri: avatarPlaceholder }
                    }
                    return <Image source={src} style={styles.avatar} />
                })()}
                <Text style={styles.userName}>{userReaction.user_name}</Text>
            </View>

            {userReaction && userReaction.reaction_index !== 0 ? (
                <Image source={getReactionAsset(userReaction.reaction_name)} style={styles.reactionIcon} />
            ) : (
                <Image source={require('../../../assets/reactions/heart.png')} size={26} style={styles.reactionIcon} />
            )}
        </View>
    )
}

export const ReactionItem = ({ reaction, onClickReaction }) => {
    const width = (Dimensions.get('window').width - 30) / 5

    return (
        <View>
            <TouchableOpacity style={styles.containerReactionItem} onPress={() => onClickReaction(reaction)}>
                {reaction && reaction.index !== 0 ? (
                    <Image
                        source={getReactionAsset(reaction?.name)}
                        style={reaction.isSelected ? styles.reactionSelected : styles.reactionUnselected}
                    />
                ) : (
                    <Image
                        source={require('../../../assets/reactions/heart.png')}
                        style={reaction.isSelected ? styles.reactionSelected : styles.reactionUnselected}
                    />
                )}

                <Text style={reaction.isSelected ? styles.reactionCountSelected : styles.reactionCountUnselected}>{reaction.count}</Text>
            </TouchableOpacity>
        </View>
    )
}

export const ReactionsModal = ({ reactions: initialReactions, setAllReactions: setParentAllReactions, handleLikeClick, latest_reactions }) => {
    const [reactions, setReactions] = useState(initialReactions)

    const onClickReaction = async (reaction) => {
        // Optimista local inmediato en el modal
        try {
            setReactions((prev) => {
                if (!Array.isArray(prev)) return prev
                const rid = reaction?._id?.toString?.() || reaction?.reaction_id?.toString?.()
                const hadSelected = prev.some((r) => (r._id?.toString?.() === rid || r.reaction_id?.toString?.() === rid) && r.isSelected)
                return prev.map((r) => {
                    const rId = r?._id?.toString?.() || r?.reaction_id?.toString?.()
                    if (rId === rid) {
                        return {
                            ...r,
                            isSelected: true,
                            count: (Number(r.count) || 0) + (hadSelected ? 0 : 1),
                        }
                    }
                    if (r.isSelected) {
                        return { ...r, isSelected: false, count: r.count > 0 ? r.count - 1 : 0 }
                    }
                    return r
                })
            })
        } catch {}

        // Llamada real (ya optimizado en el componente padre)
        const add_like = await handleLikeClick(reaction._id)
        if (Array.isArray(add_like)) setReactions(add_like)
    }

    const { languageFile } = getLanguage()

    return (
        <View style={styles.containerReactionsModal}>
            <FlatList
                data={reactions}
                keyExtractor={(item) => item._id}
                horizontal={true}
                nestedScrollEnabled={true}
                showsVerticalScrollIndicator={false}
                showsHorizontalScrollIndicator={false}
                contentContainerStyle={styles.contentContainerStyle}
                renderItem={({ item }) => <ReactionItem reaction={item} onClickReaction={onClickReaction} />}
            />

            {latest_reactions && latest_reactions?.length > 0 ? (
                <>
                    <Text style={styles.subtitleSection}>{languageFile.reactions_from_other_users}</Text>

                    <FlatList
                        data={latest_reactions}
                        keyExtractor={(item) => item._id}
                        horizontal={false}
                        nestedScrollEnabled={true}
                        showsVerticalScrollIndicator={false}
                        showsHorizontalScrollIndicator={false}
                        renderItem={({ item }) => <UserReactionItem userReaction={item} />}
                    />

                    <View style={styles.spacer1}></View>
                    <View style={styles.spacer1}></View>
                </>
            ) : (
                <>
                    <View style={styles.messageContainer}>
                        <Image style={styles.imageAsset} source={require('../../../assets/noReactions.png')} />
                        <Text style={styles.titleText}>{languageFile.no_reactions}</Text>
                        <Text style={styles.descriptionText}>{languageFile.leave_your_reaction}</Text>
                    </View>
                </>
            )}
        </View>
    )
}

const InteractionsPosts = ({
    posts,
    onCommentClick,
    comments_counter: propCommentsCounter,
    reactions,
    favourite,
    interactions,
    isGoTo,
    updateInteractions,
    onReactionPickerRef,
    showReactionPicker,
    setShowReactionPicker,
}) => {
    const { updateFavouritePostsContext, reloadFavourite, postsContext } = usePostContext()
    const apiEndpointReactions = `${apiUrl}/get_reactions_wall`
    const apiEndpoint = `${apiUrl}/add_like_wall`
    const addFavourite = `${apiUrl}/add_favourite`
    const { openBottomSheet } = useBottomSheet()
    const { languageFile } = getLanguage()
    // const snapPoints = ['55%']
    const [loading, setLoading] = useState(false)
    // const [showAlert, setShowAlert] = useState(false)
    // const [alertProps, setAlertProps] = useState({})
    const [isFavourite, setIsFavourite] = useState(favourite)

    const setInteractionsGlobal = useInteractionsStore((s) => s.setInteractions)

    const interactionFromStore = useInteractionsStore(useCallback((state) => state.interactions[String(posts?._id)], [posts?._id]))

    // ✅ Usar valor del store si está disponible, sino usar prop como fallback
    const comments_counter = interactionFromStore?.comments_counter || interactionFromStore?.comment_count || propCommentsCounter || 0

    const effectiveInteractions = interactionFromStore || interactions
    const [all_reactions, setAllReactions] = useState(() => {
        if (Array.isArray(effectiveInteractions?.reactions) && effectiveInteractions.reactions.length) return effectiveInteractions.reactions
        return reactions
    })
    const [latestReactions, setLatestReactions] = useState([])
    // countReactions derivado de all_reactions / interactions para evitar transición 0->valor y setState extra
    const countReactions = useMemo(() => {
        if (Array.isArray(all_reactions) && all_reactions.length) {
            return all_reactions.reduce((sum, r) => sum + (Number(r?.count) || 0), 0)
        }
        if (Array.isArray(effectiveInteractions?.reactions) && effectiveInteractions.reactions.length) {
            return effectiveInteractions.reactions.reduce((sum, r) => sum + (Number(r?.count) || 0), 0)
        }
        if (Array.isArray(posts?.reaction_counter) && posts.reaction_counter.length) {
            try {
                let rc = posts.reaction_counter
                if (typeof rc === 'string') {
                    const txt = rc.trim()
                    if (txt.startsWith('[')) {
                        rc = JSON.parse(txt)
                    } else {
                        rc = []
                    }
                }
                return Array.isArray(rc) ? rc.reduce((sum, r) => sum + (Number(r?.count) || 0), 0) : 0
            } catch {
                return 0
            }
        }
        return 0
    }, [all_reactions, effectiveInteractions?.reactions, posts?.reaction_counter])
    // optionSelected derivado en primer render para hidratar antes de pintar y luego sólo ajustes específicos
    const [optionSelected, setOptionSelected] = useState(() => {
        // userReaction directa
        const ur = effectiveInteractions?.user_reaction?.[0]
        if (ur && Array.isArray(reactions) && reactions.length) {
            const m = reactions.find(
                (r) => r._id?.toString?.() === ur.reaction_id?.toString?.() || r.index === ur.reaction_index || r.name === ur.name,
            )
            if (m) return { ...m, reaction_id: ur.reaction_id || m._id, isSelected: true }
        }
        // fallback al primer catálogo si hay counts
        const base = Array.isArray(reactions) ? reactions : Array.isArray(all_reactions) ? all_reactions : []
        if (base && base.length) {
            // prefer heart/like
            const def = base.find((b) => b.name === 'heart') || base.find((b) => b.name === 'like' || b.name === 'likee') || base[0]
            if (def) return { ...def, reaction_id: def._id || def.reaction_id, isSelected: !!def.isSelected }
        }
        return null
    })
    const { isConnected, hasInternet, connectedStable } = getConection()

    // Estados para long press (compartidos entre media y botón de reacciones)
    const [isLongPressingButton, setIsLongPressingButton] = useState(false)
    const longPressTimerButtonRef = useRef(null)
    const progressAnimButton = useRef(new Animated.Value(0)).current

    // const [isAlertVisible, setIsAlertVisible] = useState(false) // Estado para controlar la visibilidad del modal
    // const [alertMessage, setAlertMessage] = useState('') // Estado para el mensaje del modal
    const { setAlert } = getAlert()
    const expoConfig = Constants.expoConfig || { slug: '' }
    // Suscribir flush offline una vez montado (RN)
    useEffect(() => {
        subscribeFlushOnReconnect()
    }, [])

    // Inicializar contadores desde interactions si están disponibles
    useEffect(() => {
        // Sincronizar all_reactions con fuente más fresca (effectiveInteractions.reactions -> posts.reaction_counter)
        try {
            let next = null
            if (Array.isArray(effectiveInteractions?.reactions) && effectiveInteractions.reactions.length) {
                next = effectiveInteractions.reactions
            } else if (posts?.reaction_counter) {
                let rc = posts.reaction_counter
                if (typeof rc === 'string') {
                    try {
                        rc = JSON.parse(rc)
                    } catch {
                        rc = []
                    }
                }
                if (Array.isArray(rc)) next = rc
            }
            if (next && next !== all_reactions) {
                // Evitar set si arrays equivalentes (mismo length y mismos ids + counts)
                let different = false
                if (!Array.isArray(all_reactions) || all_reactions.length !== next.length) different = true
                else {
                    for (let i = 0; i < next.length; i++) {
                        const a = next[i]
                        const b = all_reactions[i]
                        if ((a?._id || a?.reaction_id) !== (b?._id || b?.reaction_id) || a.count !== b.count || a.isSelected !== b.isSelected) {
                            different = true
                            break
                        }
                    }
                }
                if (different) setAllReactions(next)
            }
        } catch {}
    }, [effectiveInteractions?.reactions, posts?.reaction_counter])

    useEffect(() => {
        const indexForm = postsContext.findIndex((postContext) => postContext._id === posts._id)
        if (indexForm !== -1) {
            setIsFavourite(postsContext[indexForm].status_favourite ?? favourite)
        }
    }, [reloadFavourite])

    const fetchReactions = async () => {
        try {
            if (posts?._id) {
                if (connectedStable) {
                    const authToken = await getAuthToken()
                    if (!authToken) return
                    const response = await fetch(apiEndpointReactions, {
                        method: 'GET',
                        headers: {
                            'Content-Type': 'application/json',
                            Authorization: authToken,
                            post_id: posts?._id,
                        },
                    })

                    if (response.ok) {
                        const data = await response.json()
                        if (data['status'] === 1 && data['single'] && data['single']['count_reactions'].length > 0) {
                            let count_reactions = 0
                            data['single']['count_reactions'].forEach((item) => {
                                count_reactions += item.count
                            })
                            // countReactions derivado: se elimina SetCountReactions (obsoleto)
                            setLatestReactions(data['single']['latest_reactions'])
                            setAllReactions(data['single']['count_reactions'])
                            let reaction_selected = data.single.count_reactions.find((option) => option.isSelected === true)
                            if (reaction_selected) {
                                setOptionSelected(reaction_selected)
                            } else {
                                // Fallback visual: priorizar 'heart' o 'like' si existen
                                let reaction_default =
                                    all_reactions.find((option) => option.name === 'heart') ||
                                    all_reactions.find((option) => option.name === 'like') ||
                                    all_reactions[0]
                                setOptionSelected(reaction_default)
                            }
                            // seteo la cantidad total de reacciones
                            await update_like_local_posts(posts._id, data.single.count_reactions)
                            return data['single']
                        }
                    } else {
                        throw new Error('Fallo al obtener las reacciones')
                    }
                } else {
                    let database = await openDB()
                    let get_post = await get_post_by_id(database, posts._id)
                    let count_reactions = 0
                    get_post['reaction_counter'].forEach((item) => {
                        count_reactions += item.count
                    })
                    // countReactions derivado: se elimina SetCountReactions (obsoleto)
                    setAllReactions(get_post['reaction_counter'])
                    let reaction_selected = get_post['reaction_counter'].find((option) => option.isSelected === true)
                    if (reaction_selected) {
                        setOptionSelected(reaction_selected)
                    } else {
                        let reaction_default =
                            get_post['reaction_counter'].find((option) => option.name === 'heart') ||
                            get_post['reaction_counter'].find((option) => option.name === 'like') ||
                            get_post['reaction_counter'][0]
                        setOptionSelected(reaction_default)
                    }
                    return {
                        count_reactions: get_post['reaction_counter'],
                        latest_reactions: [], // Puedes ajustar esto si es necesario
                    }
                }
            }
            return {
                count_reactions: [],
                latest_reactions: [],
            }
        } catch (err) {
            error('Reactions', 'Error en la solicitud de reacciones:', err)
            return {
                count_reactions: [],
                latest_reactions: [],
            }
        }
    }

    const OpenReactions = async () => {
        if (!isConnected && !hasInternet) {
            setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
            return
        }
        try {
            const fetch_reactions = await fetchReactions()
            debug('Reactions', 'OpenReactions counts len', fetch_reactions?.count_reactions?.length || 0)
            const counts = Array.isArray(fetch_reactions?.count_reactions) ? fetch_reactions.count_reactions : []
            // Catálogo autorizado desde props
            const defs = Array.isArray(reactions) ? reactions : []
            lazy('Reactions', 'debug', () => ['OpenReactions defs', { len: defs.length, names: defs.map((d) => d?.name).join(', ') }])
            // user_reaction para marcar selección
            const ur = effectiveInteractions?.user_reaction?.[0]
            const urId = ur?.reaction_id?.toString?.()
            const merged = defs.map((def) => {
                const found = counts.find((c) => (c?.reaction_id || c?._id)?.toString?.() === def?._id?.toString?.())
                const isSel = urId && def?._id?.toString?.() === urId
                return {
                    ...def,
                    count: Number(found?.count) || 0,
                    isSelected: !!isSel,
                }
            })
            lazy('Reactions', 'debug', () => ['OpenReactions merged', merged.map((m) => ({ name: m.name, count: m.count, sel: m.isSelected }))])
            // Usar snapPoints para evitar ScrollView contenedor y prevenir nested VirtualizedList warning en Android
            console.log('REACCIONES ==>', merged)
            openBottomSheet(
                <ReactionsModal
                    reactions={merged}
                    setAllReactions={setAllReactions}
                    handleLikeClick={handleLikeClick}
                    latest_reactions={fetch_reactions?.latest_reactions || latestReactions}
                />,
                ['60%'],
            )
        } catch (error) {
            error('Reactions', 'OpenReactions error', error)
        }
    }

    // ✅ CRÍTICO: Escuchar cambios en interactions directamente, NO memoizar
    // porque el objeto interactions cambia de referencia con cada update
    const userReaction = effectiveInteractions?.user_reaction?.[0] || null
    const hasUserReaction = effectiveInteractions?.user_reaction?.length > 0

    useEffect(() => {
        // Fallback temprano: si aún no tenemos user_reaction pero el prop reactions trae una marcada
        try {
            if (!hasUserReaction && Array.isArray(reactions) && reactions.length > 0 && !optionSelected) {
                const marked = reactions.find((r) => r?.isSelected)
                if (marked) {
                    const opt = {
                        ...marked,
                        reaction_id: marked?.reaction_id || marked?._id,
                        isSelected: true,
                    }
                    setOptionSelected(opt)
                } else {
                    // Elegir un default visual razonable
                    const def = reactions.find((r) => r.name === 'heart') || reactions.find((r) => r.name === 'like') || reactions[0]
                    if (def) setOptionSelected({ ...def, reaction_id: def?._id || def?.reaction_id, isSelected: false })
                }
            }
        } catch {}

        try {
            if (hasUserReaction && userReaction) {
                // ✅ FIX: Si ya tenemos optionSelected Y el reaction_id coincide Y está seleccionado, NO HACER NADA
                if (optionSelected && optionSelected.reaction_id === userReaction.reaction_id && optionSelected.isSelected === true) {
                    return
                }

                // Si el usuario tiene una reacción pero las reacciones reales no se han cargado, ESPERAR
                if (!reactions || reactions.length === 0) {
                    return // No establecer optionSelected todavía
                }

                // Normalizar el nombre del userReaction para matching
                const normalizedUserReactionName = userReaction.name?.trim().toLowerCase()

                // Ahora sí usamos las reacciones reales cargadas
                let reaction_selected = reactions.find((re) => re._id.toString() === userReaction.reaction_id.toString())
                debug('Reactions', 'Match by _id', !!reaction_selected)

                if (!reaction_selected && userReaction.reaction_index !== undefined) {
                    // Fallback: buscar por index si no se encontró por _id
                    reaction_selected = reactions.find((re) => re.index === userReaction.reaction_index)
                    debug('Reactions', 'Match by index', !!reaction_selected)
                }

                if (!reaction_selected && normalizedUserReactionName) {
                    // Fallback 2: buscar por name (normalizado) si no se encontró por _id ni index
                    reaction_selected = reactions.find((re) => re.name?.trim().toLowerCase() === normalizedUserReactionName)
                }

                if (reaction_selected) {
                    const updateOptionSelected = {
                        ...reaction_selected,
                        reaction_id: userReaction.reaction_id,
                        isSelected: true,
                        name: reaction_selected.name,
                        index: reaction_selected.index,
                    }
                    // Guardar sólo si cambia algo relevante
                    setOptionSelected((prev) => {
                        if (prev && prev.reaction_id === updateOptionSelected.reaction_id && prev.isSelected === updateOptionSelected.isSelected) {
                            return prev
                        }
                        return updateOptionSelected
                    })
                } else {
                    // Si aún no se encuentra después de cargar reactions, buscar "like" como fallback seguro
                    warn('Reactions', 'Reaction not found', { reaction_id: userReaction.reaction_id })

                    // Intentar buscar "like" como fallback
                    const likeFallback = reactions.find((r) => r.name === 'heart') || reactions.find((r) => r.name === 'like') || reactions[0]
                    const fallbackOption = {
                        ...likeFallback,
                        reaction_id: userReaction.reaction_id,
                        isSelected: true,
                    }
                    setOptionSelected((prev) => {
                        if (prev && prev.reaction_id === fallbackOption.reaction_id) return prev
                        return fallbackOption
                    })
                }
            } else {
                // No hay user_reaction - no forzar ni corazón ni selección si el post no tiene reacciones aún

                const totalCounts = Array.isArray(effectiveInteractions?.reactions)
                    ? effectiveInteractions.reactions.reduce((acc, r) => acc + (Number(r?.count) || 0), 0)
                    : 0

                if (!reactions || reactions.length === 0 || totalCounts === 0) {
                    // Estado neutro: no opción por defecto, dejar ícono neutro
                    if (optionSelected !== null) {
                        setOptionSelected(null)
                    }
                } else {
                    // Hay catálogo y hay reacciones en el post, usar default visual no seleccionado
                    const availableReactions = reactions
                    const reaction_default =
                        availableReactions.find((option) => option.name === 'heart') ||
                        availableReactions.find((option) => option.name === 'like') ||
                        availableReactions[0]
                    if (reaction_default) {
                        // Asegurar reaction_id estable para evitar setState repetitivo
                        const defaultOption = {
                            ...reaction_default,
                            reaction_id: reaction_default?.reaction_id || reaction_default?._id,
                            isSelected: false,
                        }
                        setOptionSelected((prev) => {
                            if (prev && prev.reaction_id === defaultOption.reaction_id && prev.isSelected === defaultOption.isSelected) return prev
                            debug('Reactions', 'Setting default (unselected)')
                            return defaultOption
                        })
                    } else {
                        setOptionSelected(null)
                    }
                }
            }

            // countReactions ahora es derivado -> no setear
        } catch (error) {
            error('Interactions', 'useEffect error', error)
        }
    }, [effectiveInteractions])

    // (Eliminado ReactionButton local - ya no se usa tras centralizar assets)

    // Handler para seleccionar reacción desde el picker del botón
    const handleReactionSelectFromButton = useCallback(async (reactionId) => {
        setShowReactionPickerButton(false)
        if (reactionId) {
            try {
                await handleLikeClick(reactionId)
            } catch (error) {
                error('Interactions', 'Error handling reaction', error)
            }
        }
    }, [])

    const likeLockRef = useRef(false)
    const handleLikeClick = async (reaction_id) => {
        try {
            console.log('2handleLikeClick Reactions handleLikeClick', { reaction_id })
            setLoading(true)

            if (!isConnected || !hasInternet) {
                setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
                return
            }

            if (likeLockRef.current) return
            likeLockRef.current = true
            const prevUserReactionId = userReaction?.reaction_id?.toString?.() || null
            const isToggleSame = prevUserReactionId && prevUserReactionId === reaction_id?.toString?.()

            // Optimismo completo sobre counts
            let optimisticCounts = all_reactions
            if (Array.isArray(all_reactions) && all_reactions.length) {
                if (isToggleSame) {
                    // Quitar reacción
                    optimisticCounts = all_reactions.map((r) => {
                        const rid = (r.reaction_id || r._id)?.toString?.()
                        if (rid === prevUserReactionId) {
                            return { ...r, count: r.count > 0 ? r.count - 1 : 0, isSelected: false }
                        }
                        return r
                    })
                    setOptionSelected(null)
                } else {
                    optimisticCounts = all_reactions.map((r) => {
                        const rid = (r.reaction_id || r._id)?.toString?.()
                        if (rid === prevUserReactionId) {
                            return { ...r, count: r.count > 0 ? r.count - 1 : 0, isSelected: false }
                        }
                        if (rid === reaction_id?.toString?.()) {
                            return { ...r, count: (r.count || 0) + 1, isSelected: true }
                        }
                        return r
                    })
                    const newSel = optimisticCounts.find((r) => (r.reaction_id || r._id)?.toString?.() === reaction_id?.toString?.())
                    if (newSel) {
                        // Asegurar nombre/index para que el icono cambie inmediatamente
                        let enriched = { ...newSel }
                        if (!enriched.name) {
                            const defMatch = Array.isArray(reactions)
                                ? reactions.find((d) => d._id?.toString?.() === reaction_id?.toString?.())
                                : null
                            if (defMatch) {
                                enriched.name = defMatch.name
                                if (enriched.index == null && defMatch.index != null) enriched.index = defMatch.index
                            }
                        }
                        setOptionSelected({ ...enriched, reaction_id: enriched.reaction_id || enriched._id, isSelected: true })
                    }
                }
                setAllReactions(optimisticCounts)
                // Propagar inmediatamente al store global y al padre
                const optimisticInteraction = {
                    ...(effectiveInteractions || {}),
                    post_id: String(posts?._id),
                    reactions: optimisticCounts,
                    user_reaction: isToggleSame
                        ? []
                        : [
                              {
                                  reaction_id: isToggleSame ? null : reaction_id,
                                  _id: isToggleSame ? null : reaction_id,
                                  name: isToggleSame
                                      ? undefined
                                      : optimisticCounts.find((r) => (r.reaction_id || r._id)?.toString?.() === reaction_id?.toString?.())?.name ||
                                        'like',
                                  reaction_name: isToggleSame
                                      ? undefined
                                      : optimisticCounts.find((r) => (r.reaction_id || r._id)?.toString?.() === reaction_id?.toString?.())?.name ||
                                        'like',
                                  isSelected: !isToggleSame,
                              },
                          ],
                }
                setInteractionsGlobal({ [String(posts?._id)]: optimisticInteraction })
                try {
                    updateInteractions?.(optimisticInteraction)
                } catch {}
            }

            // Iniciar fetch real (sin bloquear UI); spinner sólo si tarda >600mss
            let showLoading = true
            const loadingTimeout = setTimeout(() => {
                if (showLoading) setLoading(true)
            }, 600)
            // console.log('🚀 ~ handleLikeClick ~ reaction_id:', reaction_id, posts?._id)
            const authToken = await getAuthToken()
            if (!authToken) {
                // setAlert('No estás autenticado. Inicia sesión para reaccionar.', 'white', 'user-x', 'rgba(0, 0, 0, 0.8)')
                showLoading = false
                clearTimeout(loadingTimeout)
                setLoading(false)
                likeLockRef.current = false
                throw new Error('No auth token available')
            }
            let headers = {
                'Content-Type': 'application/json',
                Authorization: authToken,
                post_id: posts?._id,
            }
            if (reaction_id) {
                headers.reaction_id = reaction_id
            }
            const response = await fetch(apiEndpoint, {
                method: 'POST',
                headers: headers,
            })

            if (!response.ok) {
                throw new Error('Fallo al obtener los posts')
            }
            const data = await response.json()
            const statusReaction = data?.single?.status_reaction
            const selectedIdFromApi = data?.single?.reaction_id?.toString?.()
            // debug('Reactions', 'API Response', {
            //     statusReaction,
            //     reaction_id: selectedIdFromApi,
            //     count_len: (data?.single?.count_reactions || []).length,
            // })

            TrackingServices.addTracking(data.single.reaction_id, 'add_like_wall', 'posts')

            // Normalizar counts y marcar selección según reaction_id devuelto por el backend
            const normalizedCounts = (data?.single?.count_reactions || []).map((item) => {
                const rid = item?.reaction_id || item?._id
                const idStr = rid?.toString?.()
                return {
                    ...item,
                    reaction_id: rid,
                    _id: item?._id || rid,
                    name: item?.name || item?.reaction_name,
                    index: typeof item?.reaction_index === 'number' ? item.reaction_index : item?.index,
                    count: Number(item?.count) || 0,
                    isSelected: statusReaction === 1 && selectedIdFromApi && idStr === selectedIdFromApi,
                }
            })
            // totalCount se calcula de normalizedCounts, pero countReactions es memo derivado -> no setState adicional
            // const totalCount = normalizedCounts.reduce((acc, it) => acc + (Number(it.count) || 0), 0)
            setAllReactions(normalizedCounts)
            if (data?.single?.latest_reactions) {
                setLatestReactions(data.single.latest_reactions)
            }
            let newInt = { ...(effectiveInteractions || {}) }
            try {
                if (!newInt.post_id) newInt.post_id = String(posts?._id)
            } catch {}

            let reaction_selected =
                normalizedCounts.find((r) => {
                    const rId = r?.reaction_id?.toString?.() || r?._id?.toString?.()
                    return selectedIdFromApi && rId === selectedIdFromApi
                }) || normalizedCounts.find((option) => option.isSelected)

            // debug('Reactions', 'normalizedCounts/reaction_selected/status', {
            //     normalizedCountsLen: normalizedCounts.length,
            //     hasSelected: !!reaction_selected,
            //     statusReaction,
            // })

            // Si statusReaction === 0, el usuario quitó su reacción (dislike)
            if (statusReaction === 0) {
                info('Reactions', 'User removed reaction - default unselected')
                // Buscar la reacción "like" (heart) por nombre
                let like_reaction = normalizedCounts.find((option) => option.name === 'like')
                if (!like_reaction) {
                    // Fallback: buscar "heart"
                    like_reaction = normalizedCounts.find((option) => option.name === 'heart')
                }
                if (like_reaction) {
                    const defaultOption = {
                        ...like_reaction,
                        reaction_id: like_reaction._id,
                        isSelected: false, // ✅ NO seleccionada
                    }
                    setOptionSelected((prev) => {
                        if (prev && prev.reaction_id === defaultOption.reaction_id && prev.isSelected === defaultOption.isSelected) return prev
                        debug('Reactions', 'Setting default unselected')
                        return defaultOption
                    })
                } else {
                    setOptionSelected(null)
                }
            } else if (reaction_selected != undefined && reaction_selected != null) {
                // El usuario tiene una reacción seleccionada
                const updateOptionSelected = {
                    ...reaction_selected,
                    reaction_id: reaction_selected._id,
                }
                setOptionSelected((prev) => {
                    if (prev && prev.reaction_id === updateOptionSelected.reaction_id && prev.isSelected === updateOptionSelected.isSelected)
                        return prev
                    info('Reactions', 'Setting selected reaction')
                    return updateOptionSelected
                })
            } else {
                if (statusReaction !== 1) {
                    let reaction_default =
                        normalizedCounts.find((option) => option.name === 'heart') ||
                        normalizedCounts.find((option) => option.name === 'like') ||
                        normalizedCounts[0]
                    if (reaction_default != undefined && reaction_default != null) {
                        setOptionSelected((prev) => {
                            if (prev && prev.reaction_id === reaction_default.reaction_id && prev.isSelected === reaction_default.isSelected)
                                return prev
                            debug('Reactions', 'Setting default reaction')
                            return reaction_default
                        })
                    } else {
                        warn('Reactions', 'No default reaction found')
                        setOptionSelected(null)
                    }
                } else {
                    warn('Reactions', 'statusReaction=1 pero no se encontró reacción por id; mantener estado actual')
                }
            }

            newInt.reactions = normalizedCounts
            newInt.latest_reactions = data.single?.latest_reactions
            let selected = statusReaction === 1

            // Si el usuario quitó la reacción (statusReaction === 0)
            if (statusReaction === 0) {
                info('Reactions', 'Removing user_reaction (statusReaction = 0)', { postId: posts._id })
                newInt.user_reaction = []
                debug('Reactions', 'user_reaction cleared')
            } else if (newInt.user_reaction && newInt.user_reaction.length > 0) {
                // El usuario tiene una reacción y la está actualizando
                if (reaction_selected != undefined && reaction_selected != null) {
                    newInt.user_reaction[0].name = reaction_selected.name
                    newInt.user_reaction[0].reaction_name = reaction_selected.name
                    newInt.user_reaction[0].reaction_id = reaction_selected._id
                    newInt.user_reaction[0]._id = reaction_selected._id
                    newInt.user_reaction[0].isSelected = reaction_selected.isSelected
                    newInt.user_reaction[0].reaction_index = reaction_selected.index
                } else {
                    newInt.user_reaction[0].isSelected = selected
                }
            } else {
                // Crear nuevo user_reaction con todos los datos necesarios
                const selectedReactionData = reaction_selected || normalizedCounts.find((r) => r.isSelected)
                debug('Reactions', 'Creating new user_reaction')
                newInt.user_reaction = [
                    {
                        reaction_id: selectedReactionData?._id || data.single.reaction_id,
                        _id: selectedReactionData?._id || data.single.reaction_id,
                        name: selectedReactionData?.name || 'like',
                        reaction_name: selectedReactionData?.name || 'like',
                        reaction_index: selectedReactionData?.index !== undefined ? selectedReactionData.index : 0,
                        isSelected: selected,
                    },
                ]
                debug('Reactions', 'New user_reaction created')
            }

            // debug('Reactions', 'Final user_reaction length', (newInt.user_reaction || []).length)
            // info('Reactions', 'Calling updateInteractions', { postId: posts._id })
            const finalInteraction = { ...newInt, post_id: String(posts?._id) }
            setInteractionsGlobal({ [String(posts?._id)]: finalInteraction })
            updateInteractions(finalInteraction)

            const res = await update_like_local_posts(posts._id, normalizedCounts)

            removeCacheByFragment('get_reactions_wall_according_id')
            // setLoading(false)
            // likeLockRef.current = false
            return data['single']['count_reactions']
        } catch (error) {
            console.error('Reactions', 'Unexpected error in handleLikeClick', error)
            setAlert('Ocurrió un error inesperado. Intenta nuevamente.', 'white', 'alert-circle', 'rgba(0, 0, 0, 0.8)')
        } finally {
            setLoading(false)
            likeLockRef.current = false
        }
    }

    // Exponer handleLikeClick a través de la ref para el selector de reacciones en web
    useEffect(() => {
        if (onReactionPickerRef) {
            onReactionPickerRef.current = handleLikeClick
        }
    }, [handleLikeClick, onReactionPickerRef])
    const saveFavorite = async (postID) => {
        try {
            // console.log('🚀 ~ saveFavorite ~ postID:', postID, isFavourite, connectedStable)
            if (connectedStable) {
                TrackingServices.addTracking(postID, 'add_favourite', 'post_favourites')
                const authToken = await getAuthToken()
                if (!authToken) return
                const response = await fetch(addFavourite, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: authToken,
                        post_id: postID,
                    },
                })

                if (!response.ok) {
                    throw new Error('Fallo al obtener los favoritos')
                }
                const data = await response.json()

                // console.log('🚀 ~ saveFavorite ~ data:', data)
                updateFavouritePostsContext(posts._id, data['single']['status_favourite'])

                setIsFavourite(data['single']['status_favourite'])

                const res = await update_favourite_local_posts(posts._id, data['single']['status_favourite'])
                // console.log('🚀 ~ saveFavorite ~ res:', res)
            } else {
                // Offline: toggle local y encolar
                const next = isFavourite === 1 ? 0 : 1
                setIsFavourite(next)
                try {
                    updateFavouritePostsContext(posts._id, next)
                } catch {}
                try {
                    await update_favourite_local_posts(posts._id, next)
                } catch {}
                try {
                    await enqueue(createAction('favourite', String(postID), { status: next }))
                } catch {}
                setAlert('Favorito guardado offline. Se sincronizará al reconectar.', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
            }
        } catch (err) {
            error('Interactions', 'Error en la solicitud de like 1:', err)
        }
    }
    async function shareLink(link) {
        try {
            let message = Platform.OS != 'android' ? 'Comparte este enlace\n' : `Comparte este enlace\n${link}`
            let url = link
            const result = await Share.share({
                message: message,
                url: url, // en iOS podés usar también esta propiedad
                title: posts.title,
            })

            if (result.action === Share.sharedAction) {
                if (result.activityType) {
                    debug('Share', 'Compartido con actividad', result.activityType)
                } else {
                    info('Share', 'Compartido')
                }
            } else if (result.action === Share.dismissedAction) {
                debug('Share', 'Cancelado')
            }
        } catch (error) {
            error('Share', 'Error al compartir', error?.message)
        }
    }

    const fontScale = 1

    // ✅ Manejador de clic del botón (FUERA de RenderButtonLike para tener acceso a reactions y handleLikeClick)
    const handleButtonClick = useCallback(() => {
        console.log('1handleButtonClick --- isConnected:', isConnected, 'hasInternet:', hasInternet)
        if (!isConnected || !hasInternet) {
            setAlert('No puedes realizar esta acción sin conexión a internet', 'white', 'wifi-off', 'rgba(0, 0, 0, 0.8)')
            return
        }
        console.log('Reactions handleButtonClick START', { showReactionPicker, hasOption: !!optionSelected, reactionsLen: reactions?.length })
        // ✅ Solo verificar si el picker está abierto
        if (showReactionPicker) {
            debug('Reactions', 'SKIPPING - picker is open')
            return
        }

        // ✅ LÓGICA: Manejar todas las reacciones correctamente
        // Like puede ser 'like', 'likee' o 'heart' dependiendo de la configuración del servidor
        const isLikeReaction = (name) => name === 'like' || name === 'likee' || name === 'heart'
        const hasLike = optionSelected?.isSelected && isLikeReaction(optionSelected?.name)
        const hasOtherReaction = optionSelected?.isSelected && !isLikeReaction(optionSelected?.name)

        debug('Reactions', 'state before click', { hasLike, hasOtherReaction })

        if (hasLike) {
            // Caso 1: Ya tiene like → quitarlo (dislike)
            info('Reactions', 'CASE 1: User has like, removing it (dislike)')
            handleLikeClick(optionSelected.reaction_id)
        } else if (hasOtherReaction) {
            // Caso 2: Tiene otra reacción → cambiar a like
            info('Reactions', 'CASE 2: User has other reaction, changing to like')
            // Buscar 'like', 'likee' o 'heart' como fallback
            const likeReaction = reactions?.find((r) => isLikeReaction(r.name))
            if (!likeReaction) {
                error('Reactions', 'Like reaction not found!')
                return
            }
            handleLikeClick(likeReaction._id)
        } else {
            // Caso 3: No tiene ninguna reacción → agregar like
            info('Reactions', 'CASE 3: No reaction, adding like')
            // Buscar 'like', 'likee' o 'heart' como fallback
            const likeReaction = reactions?.find((r) => isLikeReaction(r.name))
            if (!likeReaction) {
                error(
                    'Reactions',
                    'Like/Heart reaction not found!',
                    reactions?.map((r) => r.name),
                )
                return
            }
            debug('Reactions', 'Found like/heart reaction')
            handleLikeClick(likeReaction._id)
        }
        debug('Reactions', 'handleButtonClick END (success)')
    }, [showReactionPicker, optionSelected, reactions, handleLikeClick, isConnected, hasInternet])

    const RenderButtonLike = useCallback(() => {
        // Asegurar que siempre hay un valor válido
        const currentOption = optionSelected || { name: 'like', isSelected: false, reaction_id: '' }
        const reactionCount = countReactions || 0

        const progressBarWidth = progressAnimButton.interpolate({
            inputRange: [0, 1],
            outputRange: ['0%', '100%'],
        })

        // Ref para saber cuándo empezó el mouse down
        const mouseDownTimeRef = useRef(null)

        // Handlers para mouse events (web only)
        const handleMouseDown = (e) => {
            if (Platform.OS !== 'web') return
            debug('Reactions', 'Mouse down - starting timer')

            mouseDownTimeRef.current = Date.now()

            // ✅ DELAY de 200ms antes de iniciar la animación de long press
            // Esto permite que clicks rápidos no muestren la animación
            longPressTimerButtonRef.current = setTimeout(() => {
                setIsLongPressingButton(true)

                Animated.timing(progressAnimButton, {
                    toValue: 1,
                    duration: 800, // 800ms restantes = 1000ms total
                    useNativeDriver: false,
                }).start()

                // Timer para abrir el picker después de 1000ms total
                longPressTimerButtonRef.current = setTimeout(() => {
                    debug('Reactions', 'Long press complete - showing picker')
                    setShowReactionPicker(true)
                    setIsLongPressingButton(false)
                    progressAnimButton.setValue(0)
                }, 800)
            }, 200) // Delay inicial de 200ms
        }

        const handleMouseUp = (e) => {
            if (Platform.OS !== 'web') return

            const pressDuration = Date.now() - (mouseDownTimeRef.current || 0)
            debug('Reactions', 'Mouse up', { pressDuration, isLongPressingButton, showReactionPicker })

            progressAnimButton.setValue(0)

            // Limpiar todos los timers
            if (longPressTimerButtonRef.current) {
                clearTimeout(longPressTimerButtonRef.current)
                longPressTimerButtonRef.current = null
            }

            // ✅ Si fue un clic corto (< 500ms) y NO se abrió el picker, ejecutar handleButtonClick
            const wasShortClick = pressDuration < 500 && !showReactionPicker

            setIsLongPressingButton(false)
            mouseDownTimeRef.current = null

            if (wasShortClick) {
                debug('Reactions', 'Short click detected - executing handleButtonClick')
                handleButtonClick()
            } else {
                debug('Reactions', 'Not a short click - skipping', pressDuration)
            }
        }

        const handleMouseLeave = (e) => {
            if (Platform.OS !== 'web') return
            debug('Reactions', 'Mouse leave - canceling timer')

            progressAnimButton.setValue(0)
            setIsLongPressingButton(false)

            if (longPressTimerButtonRef.current) {
                clearTimeout(longPressTimerButtonRef.current)
                longPressTimerButtonRef.current = null
            }

            mouseDownTimeRef.current = null
        }

        // Bounce en el contador ante cambios de reacción
        const bounceScale = useRef(new Animated.Value(1)).current
        useEffect(() => {
            try {
                Animated.sequence([
                    Animated.spring(bounceScale, { toValue: 1.15, friction: 5, tension: 140, useNativeDriver: true }),
                    Animated.spring(bounceScale, { toValue: 1, friction: 5, tension: 140, useNativeDriver: true }),
                ]).start()
            } catch {}
        }, [reactionCount])

        // Componente memoizado para el icono de reacción
        const ReactionIcon = useMemo(() => {
            if (!currentOption) {
                return <ActivityIndicator color={theme.colors.colorPrimary} size={24} />
            }

            // Tratar 'heart' como una variante de like
            const isLikeReaction = (name) => name === 'like' || name === 'likee' || name === 'heart'
            const displayName = currentOption?.name || currentOption?.reaction_name
            const isLike = isLikeReaction(displayName)

            // Mostrar imagen de reacción sólo si NO es un like/heart y hay un nombre válido
            if (displayName && !isLike) {
                const reactionImage = getReactionAsset(displayName)
                return (
                    <Image
                        source={reactionImage}
                        style={currentOption.isSelected ? styles.optionSelected : styles.optionUnselected}
                        onError={() => error('Reactions', 'ReactionIcon failed to load', displayName)}
                    />
                )
            }

            // Si es un like/heart seleccionado, corazón relleno
            if (currentOption.isSelected) {
                return <Ionicons name='heart' size={25} color={theme.colors.colorHeart} style={styles.iconReactionPosts} />
            }

            // Si NO hay ninguna reacción aún en el post y el usuario no reaccionó, NO mostrar corazón por defecto
            // Mostrar un ícono neutro
            if (!currentOption.isSelected && (reactionCount === 0 || !reactionCount)) {
                return <Ionicons name='happy-outline' size={25} color={'#9E9E9E'} style={styles.iconReactionPosts} />
            }

            // Caso por defecto: corazón outline (hay reacciones en el post pero el usuario no reaccionó)
            return <Ionicons name='heart-outline' size={25} color={theme.colors.colorHeart} style={styles.iconReactionPosts} />
        }, [currentOption?.name, currentOption?.reaction_name, currentOption?.isSelected, currentOption?.reaction_id, reactionCount])

        return (
            <View style={{ position: 'relative' }}>
                <TouchableOpacity
                    style={styles.reactionSector}
                    onPress={handleButtonClick}
                    onLongPress={Platform.OS !== 'web' ? OpenReactions : undefined}
                    onMouseDown={Platform.OS === 'web' ? handleMouseDown : undefined}
                    onMouseUp={Platform.OS === 'web' ? handleMouseUp : undefined}
                    onMouseLeave={Platform.OS === 'web' ? handleMouseLeave : undefined}
                >
                    {/* Mostrar siempre el icono para que el asset cambie de inmediato */}
                    {ReactionIcon}

                    <Animated.View style={[styles.footerPostTexts, { transform: [{ scale: bounceScale }] }]}>
                        <StyledText fontSize='smallText' fontWeight='bold'>
                            {parseThousands(reactionCount)}{' '}
                            {reactionCount === 1 && fontScale > 1
                                ? 'Reacc...'
                                : reactionCount === 1
                                ? languageFile.reaction || 'Reacción'
                                : fontScale > 1
                                ? 'Reacc...'
                                : languageFile.reactions || 'Reacciones'}
                        </StyledText>
                    </Animated.View>
                </TouchableOpacity>

                {/* Spinner pequeño superpuesto cuando hay loading real */}
                {/* {loading && (
                    <View style={{ position: 'absolute', left: 6, top: 6 }} pointerEvents='none'>
                        <ActivityIndicator color={theme.colors.colorPrimary} size={16} />
                    </View>
                )} */}

                {/* Overlay de progreso durante long press */}
                {isLongPressingButton && (
                    <View
                        style={{
                            position: 'absolute',
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            backgroundColor: 'rgba(0, 0, 0, 0.1)',
                            justifyContent: 'center',
                            alignItems: 'center',
                            borderRadius: 8,
                            pointerEvents: 'none',
                        }}
                    >
                        <View
                            style={{
                                width: '90%',
                                height: 4,
                                backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                borderRadius: 2,
                                overflow: 'hidden',
                            }}
                        >
                            <Animated.View
                                style={{
                                    height: '100%',
                                    backgroundColor: theme.colors.colorPrimary,
                                    width: progressBarWidth,
                                }}
                            />
                        </View>
                    </View>
                )}
            </View>
        )
    }, [optionSelected, loading, countReactions, languageFile, fontScale, isLongPressingButton, showReactionPicker, progressAnimButton, reactions, isConnected, hasInternet])

    //console.log('fontScale: ' + fontScale)
    return (
        <>
            <View style={[styles.interactionsLine, { marginTop: isGoTo ? 16 : 0 }]}>
                <View style={styles.footerPost}>
                    {expoConfig.slug != 'lesaffre-one' && (
                        <>
                            {/* Botón Me gusta */}
                            <RenderButtonLike />
                            {/* 
                                <TouchableOpacity
                                    style={styles.reactionSector}
                                    onPress={() => handleLikeClick(optionSelected ? optionSelected._id : '')}
                                    onLongPress={() => OpenReactions()}
                                >
                                    <>
                                        <Text>{optionSelected == undefined || optionSelected == null ? '0' : '1'}</Text>
                                    </>
                                    {!loading ? (
                                        <>
                                            {optionSelected && optionSelected.index !== 0 ? (
                                                <Image
                                                    source={getReactionAsset(optionSelected.name)}
                                                    style={optionSelected.isSelected ? styles.optionSelected : styles.optionUnselected}
                                                />
                                            ) : optionSelected && optionSelected.isSelected ? (
                                                <Image
                                                    source={require('../../../assets/reactions/heart.png')}
                                                    style={optionSelected.isSelected ? styles.optionSelected : styles.optionUnselected}
                                                />
                                            ) : (
                                                <Feather name='heart' size={24} color={theme.colors.colorHeart} style={styles.iconReactionPosts} />
                                            )}
                                        </>
                                    ) : (
                                        <ActivityIndicator color={theme.colors.colorPrimary} size={24} />
                                    )}

                                    <View style={styles.footerPostTexts}>
                                        <StyledText fontSize='smallText' fontWeight='bold'>
                                            {parseThousands(countReactions || 0)}
                                        </StyledText>
                                    </View>
                                </TouchableOpacity>
                            */}
                            {/* Botón Comentarios */}
                            {expoConfig.slug != 'one-pfizer' && (
                                <TouchableOpacity
                                    style={styles.reactionSector}
                                    onPress={(e) => {
                                        if (e && e.preventDefault) e.preventDefault()
                                        if (e && e.stopPropagation) e.stopPropagation()
                                        onCommentClick(e)
                                    }}
                                >
                                    <Feather name='message-square' size={24} color={theme.colors.colorComment} style={styles.iconReactionPosts} />
                                    {/*<Ionicons name='chatbox-outline' size={25} color={theme.colors.colorComment} style={styles.iconReactionPosts} />*/}

                                    <View style={styles.footerPostTexts}>
                                        <StyledText fontSize='smallText' fontWeight='bold'>
                                            {parseThousands(comments_counter)}
                                            {comments_counter && comments_counter == 1 && fontScale > 1
                                                ? ' Coment...'
                                                : comments_counter && comments_counter == 1
                                                ? ' Comentario'
                                                : fontScale > 1
                                                ? ' Coment...'
                                                : ' Comentarios'}
                                        </StyledText>
                                    </View>
                                </TouchableOpacity>
                            )}
                        </>
                    )}
                    {/* Botón Compartir */}
                    {posts.link_share && posts.link_share !== '' && (
                        <TouchableOpacity style={styles.reactionSector} onPress={() => shareLink(posts.link_share)}>
                            <Feather name='send' size={25} color={theme.colors.colorShare} style={styles.iconReactionPosts} />
                        </TouchableOpacity>
                    )}
                </View>
                <View style={styles.interactionRight}>
                    <TouchableOpacity style={styles.footerPost} onPress={() => saveFavorite(posts._id)}>
                        <FontAwesome
                            name={isFavourite === 1 ? 'bookmark' : 'bookmark-o'}
                            size={24}
                            color={PostTagsTheme.tagSelectedColor}
                            style={styles.iconReactionPosts}
                        />
                        {/* content-save-settings */}
                    </TouchableOpacity>
                </View>
            </View>
        </>
    )
}

export default InteractionsPosts

const UsersReactionsDemo = [
    {
        _id: '0r9t2j340iufjpoirenfperi',
        avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png',
        name: 'fire',
        user_name: 'Juan Pirulo',
    },
    {
        _id: 'erpiofnwpeorinfpwoerinpoi',
        avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png',
        name: 'party',
        user_name: 'Juan Pirulo 2',
    },
    {
        _id: 'wp9rijfpoweirnpvoweirnvpower',
        avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png',
        name: 'angry',
        user_name: 'Juan Pirulo 3',
    },
    {
        _id: 'weporinvóweirnvpowerinvpwoerinve',
        avatar: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/a7/React-icon.svg/2300px-React-icon.svg.png',
        name: 'confused',
        user_name: 'Juan Pirulo -1',
    },
]
// If reaccion selected {imagen mas grande (+5?), nro en azul subrayado}
// Listado de reacciones ajenas, Imagen, reaccion, nombre
